import React from "react";
import { BrowserRouter } from "react-router-dom";
import config from "../config";

export default function ReactRouterProvider({ children }) {
    return (
        <BrowserRouter basename={config.basename}>
            {/* basename="/datta-able" */}
            {children}
        </BrowserRouter>
    );
}
